import React from 'react';
import { CurrentRefinementsProps } from '@white-nl/instantsearch-components/dist/types/components';
// eslint-disable-next-line import-x/no-extraneous-dependencies
import DOMPurify from 'dompurify';

export default function CurrentRefinements(
  {
    currentRefinements,
    currentRefinementsSettings,
    additionalData,
    results,
  }: CurrentRefinementsProps,
) {
  const {
    items, refine, createURL,
  } = currentRefinements;

  const { projects } = additionalData.translates;

  const {
    classNames,
  } = currentRefinementsSettings;

  const rootClassName = [
    classNames?.rootList ?? 'tag-list-wrap',
    items.length === 0 ? 'tag-list-wrap--no-results' : '',
  ].filter(Boolean).join(' ');

  return items.length ? (
    <>
      <span className="whitespace-nowrap block">
        {Craft.t(projects, 'Viewing {count,number} {count,plural,=1{case} other{cases}} in:', { count: results.nbHits })}
      </span>
      <ul className={rootClassName}>
        {items.map((item) => item.refinements.map((nested) => (
          <li key={nested.label}>
            <a
              className={classNames?.link ?? 'tag'}
              href={createURL(nested)}
              onClick={(event) => {
                event.preventDefault();
                refine(nested);
              }}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(nested.label),
              }}
              aria-label={nested.label}
            />
          </li>
        )))}
      </ul>
    </>
  ) : (
    <span className="whitespace-nowrap block text-center">{Craft.t(projects, 'Viewing {count,number} {count,plural,=1{case} other{cases}}', { count: results.nbHits })}</span>
  );
}
